import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isPlain
} from '../../common/utils';
import { ERR_REQ_CUP_ID, ERR_REP_CUP_PLAYER } from '../../common/const';

/*
协议Id 
886
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/cupplayer/
说明
实盘比赛场用户信息
请求参数
参数名称	参数类型	说明
cupId	int	场id
uid	int	可选 默认当前用户uid

*/

const cupPlayerInfo = apiRegister('cup-player', {
    protoId: 886,
    path: '/award/reality/cupplayer/',
    cache: 10,  // 默认缓存10秒
    checkQuery(Q) {
        if (!isNumber(Q.cupId)) {
            return ERR_REQ_CUP_ID // 参数错误
        }
        return 0
    },
    checkResult(R) {
        const {
            cupPlayerInfo
        } = R
        if (!isPlain(cupPlayerInfo) || !isNumber(cupPlayerInfo.cupId) || !isNumber(cupPlayerInfo.uid)) {
            return ERR_REP_CUP_PLAYER // 数据格式非法
        }
        return 0
    }
})

export const cupPlayerLoad = cupPlayerInfo.send
